import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import data from "./modules/data";
import blind from "./modules/blind";
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    data,
    blind
  },
  getters
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js